import React, { useState, useEffect } from "react";

type EditorHeaderProps = {
  handleClose: any;
  returnUrl: any;
  mode: string;
  setMode: Function;
  editor: any;
  setPath: Function;
  setLoadImage: Function;
};

const EditorHeader = ({
  handleClose,
  returnUrl,
  mode,
  setMode,
  editor,
  setPath,
  setLoadImage,
}: EditorHeaderProps) => {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("다음");

  useEffect(() => {
    if (mode === "CUT") {
      setTitle("자르기");
      setText("다음");
    } else if (mode === "GRID") {
      setTitle("바디스크린");
      setText("다음");
    } else if (mode === "DRAW") {
      setTitle("그리기");
      setText("올리기");
    }
  }, [mode]);

  const changeMode = () => {
    if (mode === "CUT") {
      setLoadImage(false);
      editor
        .crop(editor.getCropzoneRect())
        .then(function () {
          editor.stopDrawingMode();
          editor.clearUndoStack();
          editor.clearRedoStack();
          editor._clearHistory();
          editor._initHistory();
          setMode("GRID");
          setLoadImage(true);
        })
        .catch(() => {
          setLoadImage(true);
        });
    } else if (mode === "GRID") {
      setMode("DRAW");
      setLoadImage(false);
      editor
        .loadImageFromURL(editor.toDataURL(), "marge")
        .then(function (result: any) {
          editor.clearUndoStack();
          editor.clearRedoStack();
          editor._clearHistory();
          editor._initHistory();
          setLoadImage(true);
        })
        .catch(() => {
          setLoadImage(true);
        });
    } else if (mode === "DRAW") {
      returnUrl();
    }
  };

  return (
    <div className="add-comunity-header">
      <div className="cancle" onClick={handleClose}>
        취소
      </div>
      <div
        className={mode !== "DRAW" ? "text" : "text-draw"}
        dangerouslySetInnerHTML={{ __html: title }}
      ></div>
      <div className={mode === "DRAW" ? "confirm-draw" : "confirm"} onClick={changeMode}>
        {text}
      </div>
    </div>
  );
};

export default EditorHeader;
